import { createSlice } from "@reduxjs/toolkit";

import { CustomerBalanceRule } from "../../../../../services";
import { ReduxReducer } from "../../../../interface";
import { GlobalState } from "../../interface";

import { State } from "./interface";

const initialState: State = {
	subscription: {
		basic: [],
	},
};

const setSubscriptionBasicData: ReduxReducer<
	State,
	CustomerBalanceRule.Model[]
> = (state, action) => {
	state.subscription.basic = action.payload;
};

const reset: ReduxReducer<State, any> = (state) => {
	Object.keys(initialState).forEach((key) => {
		state[key] = initialState[key];
	});
};

const globalStateCustomerBalanceRuleData = createSlice({
	name: GlobalState.ConstantGlobalStateSlice.CUSTOMER_BALANCE_RULE_DATA,
	initialState,
	reducers: {
		reset,
		setSubscriptionBasicData,
	},
});

export const globalStateCustomerBalanceRuleDataAction =
	globalStateCustomerBalanceRuleData.actions;
export const globalStateCustomerBalanceRuleDataReducer =
	globalStateCustomerBalanceRuleData.reducer;
export type globalStateCustomerBalanceRuleDataState = State;

export default globalStateCustomerBalanceRuleData;
